/**
 * User API Client
 * Handles user profile operations
 */
import { config } from '../config';
import { useAuthStore } from '../../stores/auth.store';
const PEOPLE_API_URL = config.api.people;
/**
 * Get authorization headers with JWT token from auth store
 */
function getAuthHeaders() {
    const { tokens, user } = useAuthStore.getState();
    const token = tokens?.idToken;
    const tenantId = user?.tenantId || 'tenant-001';
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Tenant-Id': tenantId,
    };
}
/**
 * Get current user's profile from DynamoDB (authoritative source for roles)
 * This is called after login to get fresh user data including roles.
 *
 * GET /users/me
 */
export async function getMyUser() {
    const response = await fetch(`${PEOPLE_API_URL}/users/me`, {
        method: 'GET',
        headers: getAuthHeaders(),
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch user profile: ${response.statusText}`);
    }
    return response.json();
}
